// Pages anyone may open; every other page needs a signed-in user with a
// verified email (the router guard in main.js).
const PUBLIC_PATHS = [
  /^\/$/,
  /^\/login$/,
  /^\/iLogin$/,
  /^\/register$/,
  /^\/landing/,
  /^\/compra/,
  /^\/annunci/,
  /^\/compra-agency/,
  /^\/landing-iframe/,
  /^\/prenota-videocall$/,
  /^\/vendi$/,
  /^\/faq$/,
  /^\/agenzie(\/[^/]+){0,2}\/?$/,
  /^\/privacy-policy$/,
  /^\/cookie-policy$/,
  /^\/termini-e-condizioni$/,
  /^\/condizioni-agenzie$/,
  /^\/accordo-trattamento-dati$/,
  /^\/note-legali$/,
  /^\/segnala$/,
  /^\/configure/,
  /^\/user\/preventivi-ristrutturazione\/add/,
  /^\/user\/preventivi-ristrutturazione\/[^/]+$/
];

export function isPublicPath(path) {
  return PUBLIC_PATHS.some((pattern) => pattern.test(path));
}

// Where a visitor goes when not allowed on `path`, or null. Also used when the
// session ends on an open page (#888: getUserDetails signs a platform account
// out), so the page does not stay there without a user.
export function signedOutRedirect(user, path) {
  if (isPublicPath(path) || (user && user.emailVerified)) return null;
  return '/annunci';
}
